import { render, staticRenderFns } from "./FlippingCard.vue?vue&type=template&id=179663e0&scoped=true&"
import script from "./FlippingCard.vue?vue&type=script&lang=js&"
export * from "./FlippingCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179663e0",
  null
  
)

export default component.exports